import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PricesWrapper extends Component {
    componentDidMount() {
        const { onPriceUpdate } = this.props;
        if (onPriceUpdate) {
            onPriceUpdate();
        }
    }

    componentDidUpdate() {
        const { onPriceUpdate } = this.props;
        if (onPriceUpdate) {
            onPriceUpdate();
        }
    }

    render() {
        const { children, raceDate, courseName, raceTime, priceLocation } = this.props;
        return (
            <div
                className="js-diffusionTopicSettingsRace"
                data-diffusion-racedate={raceDate}
                data-diffusion-coursename={courseName}
                data-diffusion-racetime={raceTime}
                data-price-location={priceLocation}
            >
                {children}
            </div>
        );
    }
}

PricesWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    raceDate: PropTypes.string,
    courseName: PropTypes.string,
    raceTime: PropTypes.string,
    priceLocation: PropTypes.string,
    onPriceUpdate: PropTypes.func,
};

export default PricesWrapper;



// WEBPACK FOOTER //
// ./src/js/PricesWrapper/index.js